module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/costume_01@2x-c8885f90352d28c6fc8b86fbc7ca3dcf.webp";